import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const InactivityHandler = ({ children }) => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const logoutUser = () => {
    localStorage.clear();
    navigate('/');
  };

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(logoutUser, 15 * 60 * 1000); // 15 minutes
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    for (let event of events) {
      window.addEventListener(event, resetTimer);
    }

    resetTimer();

    return () => {
      for (let event of events) {
        window.removeEventListener(event, resetTimer);
      }
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return <>{children}</>;
};

export default InactivityHandler;
